<div 
  class="fixed inset-0 bg-black/60 bg-opacity-40 flex items-center justify-center z-[99999]"
>
<div class=" bg-white rounded-lg max-w-[96%]  sm:w-[80%] md:w-[80%] xl:max-w-6xl relative" *transloco="let t; currentLang as currentLang">
  <div 
    class=" p-6   max-h-[580px] overflow-y-auto"> 
    <h2 class="text-[#444] border-b border-dotted border-black pb-[5px] sm sm:text-xl font-bold mb-5">{{t('comapanyInfo')}}</h2>
    <span (click)="closeModal()" class="absolute top-1 right-1.5 sm:right-0.5 sm:top-0.5 z-[999999999] icon-times-o text-xs
     rounded-[50%] text-white bg-[#787E33] p-1 cursor-pointer"></span>
     <div class="sm:grid sm:grid-cols-10 grid grid-cols-1">
      <div class="sm:col-span-6 flex flex-col gap-3 justify-between">
        <!-- Company Name -->
        <p class="text-[#2B6597] text-base font-bold">{{jobdetails()?.CompnayName}}</p>
        <!-- Company Address -->
         @if(jobdetails()?.CompanyAddress){
          <div class="mb-1.5">
            <p class="text-[#333] font-bold text-sm">{{t('address')}}</p>
            <p class="text-[#444444] text-xs sm:text-sm">{{currentLang ==='en' ?  jobdetails()?.CompanyAddress : (jobdetails()?.CompanyAddress ?? '' | toBanglaNumber)}}</p>
        </div>
         }
        

        <!-- Company Business -->
         @if(jobdetails()?.CompanyBusiness){
          <div class="mb-1.5">
            <p class="text-[#333] font-bold text-sm">{{t('business')}}</p>
            <p class="text-[#444444] text-xs sm:text-sm" [innerHTML]="jobdetails()?.CompanyBusiness"></p>
         </div>
         }
         
        <p class="text-[#333] text-xs mb-3">{{t('view_details')}}</p>
      </div>
      @if(!fromNewspaper()){
        <div class="sm:col-span-4 flex-1 flex flex-col gap-2">
          @if(isFollowedLocal()){
            <div class="bg-[#f3f3f3]">
              <p class="text-sm text-[#48752F]  p-1 px-3">{{t('followsuccessAlert')}}</p>
            </div>
          }
          <p class=" text-[#444] text-xs break-words">
            {{isFollowedLocal()? t('followMsg'):t('unfollowText')}}
          </p>
          <div class="self-start sm:self-end mb-4"> 
            <button (click)="follow()"
            [ngClass]="isFollowedLocal() ? 'bg-[#d24115]' : 'bg-[#37474F]'"
             class="cursor-pointer  px-[15px] py-2 text-white flex items-center justify-center gap-1 rounded text-sm"> 
             <span [ngClass]="isFollowedLocal() ? 'icon-times-o' : 'icon-plus'" class="text-[11px]"></span><span class="text-sm">{{ isFollowedLocal() ? t('unfollow') : t('follows') }}</span></button>
          </div>
        </div>
      }
      
     </div>
      
    
      <div class="hidden sm:block overflow-x-auto rounded-md border-[0.5px] border-gray-300">
        <table class="table-auto  w-full rounded">
          <thead class="">
            <tr class=" bg-[#BABDC0] text-[#333] font-bold text-sm rounded-lg border border-gray-400">
              <th class="max-h-[38px] border-2 border-white p-2 text-center w-12 rounded-l-lg rounded-b-none">{{t('sl')}}</th>
              <th class="max-h-[38px] p-2 border-2 border-white  text-left">{{t('jobtitle')}}</th>
              <th class="max-h-[38px] px-2 border-2 border-white py-1.5 text-left w-64 text-sm rounded-r-lg rounded-b-none">{{t('deadline')}}</th>
            
            </tr>
            
          </thead>
          <tbody class="[&>tr]:border-spacing-x-4">
             @for(jobs of jobDeadlines();track $index; let i = $index){
                @if(jobs.jobAccess !== "0"){
                  <tr class=" bg-[#F3F3F3] text-sm odd:bg-[#F3F3F3] even:bg-white">
                    <td class=" px-2 py-2 w-9 text-[#333]">{{i+1 }}</td>
                    <td class="text-[#2B6597] border-2 border-white p-1 sm:p-2 sm:text-sm text-xs">
                      <a target="_blank" [href]="baseUrl+jobs.jobid+'?ln='+jobs.ln" class="hover:underline">{{jobs.jobtitle}}</a></td>
                    <td class="text-[#333] p-1 border-2 border-white sm:p-2 sm:text-sm text-xs">
                        {{
                          currentLang === 'en'
                            ? (jobs.deadline | date: 'dd MMM yyyy') + ' (' + jobs.daysRemaining() + ' days left)'
                            : 
                                ((jobs.deadline | date: 'dd MMM yyyy') ?? '' | toBanglaNumber)
                                + ' (' +
                                ((jobs.daysRemaining()) + ' days left' | toBanglaNumber)
                                + ')'   
                        }}
                    </td>
                  </tr>
                }
             }
          </tbody>
        </table>
      </div>


      <div class="block sm:hidden overflow-x-auto rounded-md border-[0.5px] border-gray-300">
        <table class="table-auto  w-full rounded">
          <thead class="">
            <tr class="bg-[#BABDC0] text-[#333] font-bold text-sm rounded-lg border border-gray-400">
              <th class="max-h-[38px] p-2 border-2 border-white  text-left">{{t('jobtitle')}} <span class="font-normal text-[#333]">({{t('deadline')}})</span>
                </th>
            </tr>
            
          </thead>
          <tbody class="[&>tr]:border-spacing-x-4">
           
             @for(jobs of jobDeadlines();track $index; let i = $index){
                @if(jobs.jobAccess !== "0"){
                  <tr class=" bg-[#F3F3F3] text-sm odd:bg-[#F3F3F3] even:bg-white">
                    <td class="text-[#2B6597] border-2 border-white p-1 sm:p-2 text-sm"><a target="_blank" [href]="baseUrl+jobs.jobid+'?ln='+jobs.ln" class="hover:underline">{{jobs.jobtitle}}</a> <span class="text-[#757575]"> {{ jobs.deadline | date:'MMMM d, y' }}
                      ({{jobs.daysRemaining() }} days left)</span></td>
                    
                  </tr>

                  
                }
                 

             }
            
             
           
            
          </tbody>
        
        </table>
      </div>
      
     
      
      
  </div>
</div>
  
</div>